import { Card, Typography } from "../material-old";
import { Collapse, Divider, message, Space } from "antd";
import React, { useEffect } from "react";
import { FolderIcon } from "@heroicons/react/24/solid";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { fetchAllBaseRequirements } from "../../redux/actions/baseRequirementsActions.tsx";
import { fetchTemplateByID } from "../../redux/actions/templatesActions.tsx";
import { BreadcrumbComponent } from "./BreadcrumbComponent.tsx";
import { CoreLoading } from "../common/CoreLoading.tsx";
import { lightBlue } from "../../utils/theme/colors.ts";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

interface Props {
  templateId: string;
}

const { Panel } = Collapse;

export const Detail: React.FC<Props> = ({ templateId }) => {
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const { activeTemplate, loading } = useAppSelector(
    (state) => state.templates,
  );
  const { results: requirements } = useAppSelector(
    (state) => state.baseRequirements,
  );

  useEffect(() => {
    handleInitializeTemplate();
  }, [templateId]);

  const handleInitializeTemplate = async () => {
    try {
      await Promise.all([
        dispatch(
          fetchAllBaseRequirements(`/docvault/base-requirements?limit=1000`),
        ),
        dispatch(fetchTemplateByID(templateId)),
      ]);
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo cargar la plantilla."));
    }
  };

  if (!activeTemplate || loading) return <CoreLoading size={1} />;

  return (
    <Card className="w-10/12 mx-auto mb-12 mt-12 p-10">
      {contextHolder}
      <div className="flex justify-end">
        <BreadcrumbComponent template={activeTemplate} />
      </div>
      <div>
        <div className="flex justify-center items-center w-full mt-4">
          <Typography variant="h5" color="blue-gray" className="mb-2">
            {activeTemplate?.name}
          </Typography>
        </div>
        <div>
          <Divider />
        </div>
        <div className="w-full">
          <Collapse accordion className={`bg-white border-none w-full`}>
            {activeTemplate.base_requirements.map((reqId, index) => (
              <Panel
                key={index}
                header={
                  <Space>
                    <FolderIcon className="h-5 w-5" color={lightBlue} />
                    {requirements.find((r) => r.id == reqId)?.name}
                  </Space>
                }
                className="border-none bg-white shadow-none h-full"
              >
                <Space className="flex flex-row cursor-pointer">
                  <span>
                    Tipo: {requirements.find((r) => r.id == reqId)?.type}
                  </span>
                </Space>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </Card>
  );
};
